export default {
      id: "icon-checkmark-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.svg#icon-checkmark",
      toString: function () {
        return this.url;
      }
    }